import { Box, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import "./App.css";
import AboutMe from "./components/AboutMe";
import Interests from "./components/Interests";
import Projects from "./components/Projects";
import Socials from "./components/Socials";
import LayoutMode from "./providers/LayoutMode";
import { MainProvider } from "./providers/MainProvider";
function App() {
  return (
    <Container maxWidth="lg">
      <LayoutMode>
        <MainProvider.Provider>
          <Grid container spacing={2}>
            <Grid
              size={{
                md: 3,
                xs: 12,
              }}
            >
              <Paper>
                <Box
                  component={"img"}
                  src={"https://avatars.githubusercontent.com/u/44467425?v=4"}
                  alt="Avatar"
                  width={"100%"}
                  height={"fit-content"}
                  sx={{ objectFit: "cover" }}
                  display={"block"}
                />
              </Paper>
            </Grid>
            <Grid
              size={{
                md: 9,
                xs: 12,
              }}
            >
              <Stack justifyContent={"space-between"} spacing={2}>
                <Paper sx={{ p: 2 }}>
                  <Typography fontWeight={"bold"} variant="h6">
                    Trần Minh Tâm
                  </Typography>
                  <Typography fontWeight={"bold"}>
                    Senior Full Stack Developer @ SPLabs
                  </Typography>
                  <Typography color="text.secondary">
                    Passionate about building high-quality software solutions
                  </Typography>
                </Paper>
                <Interests />
                <Socials />
              </Stack>
            </Grid>
            <Grid
              size={{
                xs: 12,
              }}
            >
              <Projects />
            </Grid>
            {/* <Grid
              size={{
                xs: 12,
              }}
            >
              <ProjectDetails />
            </Grid> */}
            <Grid size={12}>
              <AboutMe />
            </Grid>
          </Grid>
        </MainProvider.Provider>
      </LayoutMode>
    </Container>
  );
}

export default App;
